import React, { useEffect, useState, useRef, useCallback, useMemo } from "react";
import { Context, Hooks, Util, Request } from "@xt/xtbase";
const { XtContext, XtAuth } = Context;
const { useTranslation } = Hooks;
import XtLoading from "@/components/Xt/Loading";
import NoData from "components/App/div/noData";
import CurrencySelect from "components/Pages/Finance/_cmpt/CurrencySelect";
import useSortByApy from "components/Pages/Finance/_hook/useSortByApy";
import DropProducts from "@/components/Pages/Finance/Drop/Products";
import DropDuration from "@/components/Pages/Finance/Drop/Duration";
import DropSelect from "@/components/Pages/Finance/Drop/Select";
import TableRow from "@/components/Pages/Finance/PageSimpleEarn/AllProducts/TableRow";
import cx from "classnames";
import styles from "./index.module.less";
import stylesProducts from "@/components/Pages/Finance/Styles/products.module.less";
import { useStore } from "@/models";
import { observer } from "mobx-react-lite";
import { get_product } from "api/v4/finance";
import XtSvg from "@/components/Xt/Svg";

export default observer(() => {
  const t = useTranslation();
  const { app, finance } = useStore();

  const limit = 8;
  const fromPage = useRef(1);

  const [loading, setLoading] = useState(false);
  const [resData, setResData] = useState([]);

  const [filterProducts, setFilterProducts] = useState("SIMPLE_EARN");
  const [filterDuration, setFilterDuration] = useState("ALL");
  const [filterSelect, setFilterSelect] = useState([]);
  const [currency, setCurrency] = useState();

  const isAvailable = useMemo(() => filterSelect.includes("displayAvailableOnly"), [filterSelect]);
  const isMatchMyAssets = useMemo(() => filterSelect.includes("matchMyAssets"), [filterSelect]);
  const isSortByApy = useMemo(() => filterSelect.includes("sortByApy"), [filterSelect]);

  const [hasMore, setHasMore] = useState(false);

  const apiReq = useCallback(
    (isMore) => {
      console.log({ isAvailable, isMatchMyAssets });
      if (loading) return;
      setLoading(true);
      if (!isMore) fromPage.current = 1;

      get_product({
        params: {
          categories: filterProducts,
          available: isAvailable ? true : undefined,
          matchMyAssets: isMatchMyAssets ? true : undefined,
          // sortByApy: filterSelect.includes("sortByApy") ? true : undefined,
          duration: filterDuration,
          currency,
          limit: -1,
          fromPage: fromPage.current + (isMore ? 1 : 0),
        },
        errorPop: true,
      })
        .then((result) => {
          setResData(isMore ? [...resData, ...result.items] : result.items || []);
          setHasMore(result.hasNext);
          isMore && (fromPage.current = fromPage.current + 1);
        })
        .finally(() => {
          setLoading(false);
        });
    },
    [resData, loading, filterProducts, isAvailable, isMatchMyAssets, filterDuration, currency]
  );

  useEffect(() => {
    apiReq();
  }, [filterProducts, isAvailable, isMatchMyAssets, filterDuration, currency]);

  const onViewMore = useCallback(() => {
    apiReq(true);
  }, [apiReq]);

  const [isExpand, setIsExpand] = useState(false);
  const isMoreBtn = useMemo(() => resData.length > limit, [resData]);
  const onMoreBtnClick = useCallback(() => setIsExpand(!isExpand), [isExpand]);

  const resDataSort = useSortByApy(resData, isSortByApy);
  const items = useMemo(() => {
    const retAry = resDataSort.slice(0, isExpand ? undefined : limit);
    console.log("retAry", retAry);
    return retAry;
  }, [resDataSort, isExpand]);

  const [timestamp, setTimestamp] = useState("");
  useEffect(() => {
    setTimestamp(Date.now());
  }, [resDataSort]);

  return (
    <div className={styles.main}>
      <h2 className={stylesProducts.title}>{t("finance.allProducts")}</h2>
      <div className={stylesProducts.content}>
        <div className={stylesProducts.filterCon}>
          <div>
            <DropProducts data={filterProducts} callback={setFilterProducts} />
            <div>
              <DropDuration data={filterDuration} callback={setFilterDuration} />
              <DropSelect data={filterSelect} callback={setFilterSelect} />
            </div>
          </div>
          <div>
            <CurrencySelect className={stylesProducts.search} value={currency} onChange={setCurrency} />
          </div>
        </div>

        <div className={stylesProducts.bodyCon}>
          {!app.isH5 && (
            <div className={cx(stylesProducts.tableNav, styles.tableRowLayout)}>
              <div>{t("finance.coin")}</div>
              <div>{t("finance.apy")}</div>
              <div>{t("finance.productType")}</div>
              <div>{t("finance.durationDays")}</div>
              <div>{t("console.operate")}</div>
            </div>
          )}

          <div className={stylesProducts.tableCon}>
            {!items.length ? (
              <NoData className={stylesProducts.noData} />
            ) : (
              <>
                {items.map((data) => (
                  <TableRow key={data.groupTag + "-" + timestamp} data={data} rowCls={styles.tableRowLayout} />
                ))}

                {isMoreBtn && (
                  <div className={stylesProducts.more}>
                    <button className={cx("btnTxt")} onClick={onMoreBtnClick}>
                      <span>{isExpand ? t("finance.collapse") : t("cmpt.viewmore")}</span>
                      <XtSvg icon={"doubleArrow"} style={{ marginLeft: "5px", transform: isExpand ? "rotateZ(-90deg)" : "rotateZ(90deg)" }} />
                    </button>
                  </div>
                )}
              </>
            )}
          </div>
        </div>

        {loading && <XtLoading />}
      </div>
    </div>
  );
});
